import React from 'react'
import { Mutation, Query } from 'react-apollo'
import { gql } from 'apollo-boost'
import { Field, Formik } from 'formik'
import * as yup from 'yup'

import TextField from '../TextField'
import Text from '../Text'
import Button from '../Button'
import Loading from '../Loading'
import Form, { Heading } from '../Form'

const GET_TEMPLATE = gql`
  query template($id: ID!) {
    template(id: $id)
    {
      id
      key
      name
      description
      price
      documentation
    }
  }
`

const UPDATE_TEMPLATE = gql`
  mutation updateTemplate(
  $id: ID!
  $name: String!
  $description: String!
  $price: Float!
  $documentation: String!
  ) {
    updateTemplate(
      id: $id
      name: $name
      description: $description
      price: $price
      documentation: $documentation
    ) {
      id
    }
  }
`

const validationSchema = yup.object().shape({
  id: yup.string().required('ID is required'),
  name: yup.string().required('Name is required'),
  description: yup.string(),
  price: yup.number().positive('Price must be positive'),
  documentation: yup.string(),
})

const onSubmit = (values, {setSubmitting}, updateTemplate) => {
  updateTemplate({variables: values})
  setSubmitting(false)
}

const Update = ({id, onCompleted, onError}) =>
  <Query
    query={GET_TEMPLATE}
    variables={{id}}
    fetchPolicy='cache-and-network'>
    {({loading, error, data}) => {
      if (loading) return <Loading />
      if (error) return <Text error>{error.message}</Text>
      if (!data.template) return <Text>Nothing was found!</Text>

      return (
        <Mutation
          mutation={UPDATE_TEMPLATE}
          onCompleted={onCompleted}
          onError={onError}>
          {(updateTemplate, {loading}) =>
            <Formik
              initialValues={{
                id: data.template.id || '',
                key: data.template.key || '',
                name: data.template.name || '',
                description: data.template.description || '',
                price: data.template.price || 0,
                documentation: data.template.documentation || '',
              }}
              validationSchema={validationSchema}
              onSubmit={(values, actions) => onSubmit(values, actions, updateTemplate)}>
              {({isSubmitting, values}) =>
                <Form>
                  <Text h2 secondary mb={3}>{values.key}</Text>

                  <Heading>General</Heading>
                  <Field component={TextField} name='name' label='Publicly Visible Name' />
                  <Field component={TextField} name='description' label='Description' />
                  <Field component={TextField} name='price' label='Price in Dollars' type='number' step='0.01' placeholder='0.00' />

                  <Heading>Help</Heading>
                  <Field component={TextField} name='documentation' label='Documentation' textArea rows={10} />

                  <Button type='submit' fluid disabled={loading || isSubmitting}>Save</Button>
                </Form>
              }
            </Formik>
          }
        </Mutation>
      )
    }}
  </Query>

export default Update


// WEBPACK FOOTER //
// ./src/components/Templates/Update.js